var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 165,
    viewBox: "0 0 375 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.999954 0L375 0V165C375 165 382 101.316 300 101.316C247.862 101.316 140.34 101.316 68.94 101.316C30.2801 101.316 -0.999986 69.9757 -0.999968 31.3158L-0.999954 0Z",
    fill: "#243443"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopWave);
export default __webpack_public_path__ + "static/media/topWave.cab9c15189b20642fbf0b1f637d5d430.svg";
export { ForwardRef as ReactComponent };